import { html } from 'lit';
import { ref } from 'lit/directives/ref.js';
import { BoilerplateModal } from './boilerplate_modal';

class ModalWishlistCreateBoard extends BoilerplateModal {
  constructor() {
    super();
    this.fromBottom = true;
  }

  toggleModal(e) {
    super.toggleModal(e);

    if (this.form) {
      this.form.resetEmitter();
    }
  }

  async connectedCallback() {
    super.connectedCallback();

    // Check for missed wishlist:initialise event
    window.eventKeeper?.onEventHeard('wishlist:initialise', async (detail) => {
      this.products = await window.wishlist.getProducts();
    });

    document.addEventListener('wishlist:initialise', async () => {
      this.products = await window.wishlist.getProducts();
    });

    document.addEventListener('wishlist:remove', async () => {
      this.products = await window.wishlist.getProducts();
    });

    document.addEventListener('wishlist:update', async () => {
      this.products = await window.wishlist.getProducts();
    });
  }

  async disconnectedCallback() {
    super.disconnectedCallback();

    document.removeEventListener('wishlist:initialise', async () => {
      this.products = await window.wishlist.getProducts();
    });

    document.removeEventListener('wishlist:remove', async () => {
      this.products = await window.wishlist.getProducts();
    });

    document.removeEventListener('wishlist:update', async () => {
      this.products = await window.wishlist.getProducts();
    });
  }

  renderBody() {
    return html`<wishlist-create-board-form .detail=${this.detail} ${ref((el) => (this.form = el))}></wishlist-create-board-form>`;
  }
}

window.customElements.get('modal-wishlist-create-board') || window.customElements.define('modal-wishlist-create-board', ModalWishlistCreateBoard);
